
<div class="card-body p-2 text-dark fw-bold">
    <div class="row" [formGroup]="bankAccountForm">
        <div class="mt-2 col-xl-4 col-lg-8 col-sm-6 col-12">
            <label for="bankId" class="fw-bold">Banco</label>
            <ng-select [items]="listBanks" bindLabel="name" bindValue="_id" formControlName="bankId" id="bankId" placeholder="Banco"></ng-select>
            @if(bankAccountForm.get('bankId').touched && bankAccountForm.get('bankId').invalid){
            <small class="text-danger">Dato Obligatorio</small>
            }
        </div>
        <div class="mt-2 col-xl-4 col-lg-8 col-sm-6 col-12">
            <label for="accountTypeId" class="fw-bold">Tipo Cuenta</label>
            <ng-select [items]="listTypeAccount" bindLabel="name" bindValue="_id" formControlName="accountTypeId" id="accountTypeId" placeholder="Tipo Cuenta"></ng-select>
            @if(bankAccountForm.get('accountTypeId').touched && bankAccountForm.get('accountTypeId').invalid){
            <small class="text-danger">Dato Obligatorio</small>
            }
        </div>
        <div class="mt-2 col-xl-4 col-lg-8 col-sm-6 col-12">
            <label for="number" class="fw-bold">Número Cuenta</label>
            <input type="text" class="form-control" formControlName="number" id="number" placeholder="Número Cuenta">
            @if(bankAccountForm.get('number').touched && bankAccountForm.get('number').invalid){
            <small class="text-danger">Dato Obligatorio</small>
            }
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-12 d-flex justify-content-end gap-2 flex-wrap">
            <button type="button" class="btn btn-outline-secondary btn-xs" (click)="back.emit()"><i class="fas fa-arrow-left"></i> Volver</button>
            <button type="button" class="btn btn-outline-danger btn-xs" (click)="cancel.emit()"><i class="fas fa-times"></i> Cancelar</button>
            <button type="button" class="btn btn-primary btn-xs" (click)="submit()"><i class="fas fa-save"></i> Guardar y Continuar <i class="fas fa-arrow-right"></i></button>
        </div>
    </div>
</div>
